(function () {
  'use strict';

  var KLAVIYO_WAIT_MS = 5000;
  var KLAVIYO_POLL_INTERVAL = 200;

  function getKlaviyoLike() {
    if (window.klaviyo && (typeof window.klaviyo.push === 'function' || typeof window.klaviyo.subscribeToBackInStock === 'function')) {
      return window.klaviyo;
    }
    if (window._learnq && typeof window._learnq.push === 'function') {
      return window._learnq;
    }
    return null;
  }

  function waitForKlaviyo() {
    return new Promise(function (resolve) {
      var k = getKlaviyoLike();
      if (k) return resolve(k);
      var elapsed = 0;
      var iv = setInterval(function () {
        var k2 = getKlaviyoLike();
        if (k2) {
          clearInterval(iv);
          resolve(k2);
          return;
        }
        elapsed += KLAVIYO_POLL_INTERVAL;
        if (elapsed >= KLAVIYO_WAIT_MS) {
          clearInterval(iv);
          window._learnq = window._learnq || [];
          resolve(window._learnq);
        }
      }, KLAVIYO_POLL_INTERVAL);
    });
  }

  function subscribeBackInStock(klaviyo, variantId, email, name, productId, productHandle, variantTitle) {
    var props = {
      VariantID: String(variantId),
      ProductID: productId ? String(productId) : undefined,
      ProductHandle: productHandle || undefined,
      VariantTitle: variantTitle || undefined,
      Name: name || undefined,
      URL: location.href
    };

    var pushed = false;

    if (typeof klaviyo.push === 'function') {
      klaviyo.push(['identify', { '$email': email, '$first_name': name || undefined }]);
      klaviyo.push(['track', 'Back in Stock Requested', props]);
      pushed = true;
    }
    if (window._learnq && typeof window._learnq.push === 'function') {
      window._learnq.push(['identify', { '$email': email, '$first_name': name || undefined }]);
      window._learnq.push(['track', 'Back in Stock Requested', props]);
      pushed = true;
    }

    if (typeof klaviyo.subscribeToBackInStock === 'function') {
      try { klaviyo.subscribeToBackInStock({ variantId: String(variantId), email: email }); } catch (e) {}
    }

    return pushed ? Promise.resolve() : Promise.reject(new Error('Klaviyo SDK has no usable API'));
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  function setHidden(el, hidden) {
    if (!el) return;
    if (hidden) el.setAttribute('hidden', '');
    else el.removeAttribute('hidden');
  }

  function bind(root) {
    var variantInputs = root.querySelectorAll('[data-waitlist-variant-input]');
    var submitBtn = root.querySelector('[data-waitlist-submit]');
    var labelEl = root.querySelector('[data-waitlist-submit-label]');
    var loadingEl = root.querySelector('[data-waitlist-submit-loading]');
    var successEl = root.querySelector('[data-waitlist-success]');
    var errorEl = root.querySelector('[data-waitlist-error]');
    var formContainer = root.querySelector('[data-waitlist-form]');
    var emailEl = root.querySelector('input[name="email"]');
    var nameEl = root.querySelector('input[name="name"]');
    var honeypot = root.querySelector('input[name="website"]');

    if (!submitBtn || !variantInputs.length) return;

    function getSelectedVariantInput() {
      for (var i = 0; i < variantInputs.length; i++) {
        if (variantInputs[i].tagName === 'SELECT') {
          var opt = variantInputs[i].options[variantInputs[i].selectedIndex];
          return { value: variantInputs[i].value, getAttribute: function(a){ return opt ? opt.getAttribute(a) : null; }, label: opt ? opt.textContent.trim() : '' };
        }
        if (variantInputs[i].checked) {
          var el = variantInputs[i];
          return { value: el.value, getAttribute: function(a){ return el.getAttribute(a); }, label: el.getAttribute('data-variant-title') || '' };
        }
      }
      return null;
    }

    function setLoading(loading) {
      if (loading) {
        submitBtn.setAttribute('disabled', '');
        setHidden(labelEl, true);
        setHidden(loadingEl, false);
      } else {
        submitBtn.removeAttribute('disabled');
        setHidden(labelEl, false);
        setHidden(loadingEl, true);
      }
    }

    function resetStatus() {
      setHidden(successEl, true);
      setHidden(errorEl, true);
      setLoading(false);
    }

    var submitInFlight = false;
    function handleSubmit(evt) {
      if (evt) evt.preventDefault();
      if (submitInFlight) return;
      resetStatus();

      if (honeypot && honeypot.value) return;

      var email = (emailEl && emailEl.value || '').trim();
      var name = (nameEl && nameEl.value || '').trim();
      var selected = getSelectedVariantInput();
      var variantId = selected ? selected.value : '';

      if (!isValidEmail(email)) {
        errorEl.textContent = errorEl.dataset.invalidEmail || errorEl.textContent;
        setHidden(errorEl, false);
        return;
      }
      if (!variantId) {
        setHidden(errorEl, false);
        return;
      }

      submitInFlight = true;
      setLoading(true);

      var productId = root.getAttribute('data-product-id');
      var productTitle = root.getAttribute('data-product-title') || '';
      var productHandle = root.getAttribute('data-product-handle') || '';
      var productUrl = location.href;
      var productImage = root.getAttribute('data-product-image') || '';
      // Prefer the selected variant's own image (correct colorway) over the
      // product's default image; normalize protocol-relative URLs to https.
      var variantImage = selected ? (selected.getAttribute('data-variant-image') || '') : '';
      if (variantImage.indexOf('//') === 0) variantImage = 'https:' + variantImage;
      var bisImage = variantImage || productImage;
      var productUrlClean = root.getAttribute('data-product-url') || location.href.split('?')[0];
      var variantUrl = productUrlClean + (productUrlClean.indexOf('?') === -1 ? '?' : '&') + 'variant=' + encodeURIComponent(variantId);
      var variantTitle = selected ? selected.label : '';
      var variantPrice = selected ? (selected.getAttribute('data-price') || '') : '';
      var variantPriceAmount = selected ? (selected.getAttribute('data-price-amount') || '') : '';

      var props = {
        VariantID: String(variantId),
        ProductID: productId ? String(productId) : undefined,
        ProductTitle: productTitle || undefined,
        ProductHandle: productHandle || undefined,
        ProductImage: bisImage || undefined,
        VariantTitle: variantTitle || undefined,
        VariantPrice: variantPrice || undefined,
        VariantPriceAmount: variantPriceAmount ? Number(variantPriceAmount) : undefined,
        Name: name || undefined,
        URL: productUrl
      };

      try {
        if (window.klaviyo && typeof window.klaviyo.push === 'function') {
          var vid = String(variantId);
          var identifyProps = {
            '$email': email,
            '$first_name': name || undefined,
            // Flat keys: kept for backward-compat and as the email template's
            // fallback for profiles that subscribed before per-variant keys.
            // Single-valued, so they hold only the most recent subscription.
            'BackInStock_ProductTitle': productTitle || undefined,
            'BackInStock_ProductImage': bisImage || undefined,
            'BackInStock_ProductURL': variantUrl || undefined,
            'BackInStock_ProductHandle': productHandle || undefined,
            'BackInStock_VariantTitle': variantTitle || undefined,
            'BackInStock_VariantPrice': variantPrice || undefined,
            'BackInStock_VariantID': vid
          };
          // Per-variant keys: what the Back in Stock email template looks up
          // (BIS_<variantId>_*, matched against event.VariantId at send time).
          // Namespacing by variant lets one profile hold alerts for multiple
          // products without overwriting each other's image/URL.
          identifyProps['BIS_' + vid + '_Image'] = bisImage || undefined;
          identifyProps['BIS_' + vid + '_URL'] = variantUrl || undefined;
          identifyProps['BIS_' + vid + '_ProductTitle'] = productTitle || undefined;
          identifyProps['BIS_' + vid + '_VariantTitle'] = variantTitle || undefined;
          identifyProps['BIS_' + vid + '_VariantPrice'] = variantPrice || undefined;
          identifyProps['BIS_' + vid + '_ProductID'] = productId ? String(productId) : undefined;
          window.klaviyo.push(['identify', identifyProps]);
          window.klaviyo.push(['track', 'Back in Stock Requested', props]);
        }
      } catch (e) {}

      var bisBody = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + String(variantId) } }
          }
        }
      };
      fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=YijzC3', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'revision': '2024-10-15'
        },
        body: JSON.stringify(bisBody)
      }).then(function (r) {
        if (!r.ok && window.console) {
          r.text().then(function (t) { console.warn('[waitlist] BIS error', r.status, t); });
        }
      }).catch(function (e) {
        if (window.console) console.warn('[waitlist] BIS fetch failed', e);
      });

      setLoading(false);
      setHidden(formContainer, true);
      setHidden(successEl, false);
    }

    submitBtn.addEventListener('click', handleSubmit);
    if (emailEl) {
      emailEl.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') handleSubmit(e);
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-waitlist]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
